import { render, staticRenderFns } from "./examination-form.vue?vue&type=template&id=91cebaae&"
import script from "./examination-form.vue?vue&type=script&lang=js&"
export * from "./examination-form.vue?vue&type=script&lang=js&"
import style0 from "./examination-form.vue?vue&type=style&index=0&id=91cebaae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports